import { render, staticRenderFns } from "./CreateInfoBlock.vue?vue&type=template&id=5aa3c3d3&scoped=true"
import script from "./CreateInfoBlock.vue?vue&type=script&lang=js"
export * from "./CreateInfoBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa3c3d3",
  null
  
)

export default component.exports